import { render, staticRenderFns } from "./WithdrawalDetailsSidebar.vue?vue&type=template&id=01b288b6"
import script from "./WithdrawalDetailsSidebar.vue?vue&type=script&lang=js"
export * from "./WithdrawalDetailsSidebar.vue?vue&type=script&lang=js"
import style0 from "./WithdrawalDetailsSidebar.vue?vue&type=style&index=0&id=01b288b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports